// import data from './Lesings';

const layers = [{
        id: 2,
        naam: "Oesskatting",
        permissions: ["oesskatting:read"],
        request: {
            endpoint: "/oesskatting",
            params: ["aantaldae=14"]
        },
        filters: [{
            active: true,
            name: "Datumreeks",
            type: "daterange"
        }],
        layertipes: [{
                key: 1,
                active: false,
                name: "Heatmap",
                type: "weightedheatmap",
                options: {},
                infooverlay: true
            },
            {
                key: 2,
                active: true,
                name: "Merkers",
                type: "markers",
                options: {
                    label: "value"
                }
            }
        ],
        infobox: {
            title: "value",
            subtitle: "date",
            info: "capturer"
        }
    },
    // {
    //     id: 1,
    //     naam: "Grondvog",
    //     permissions: ["grondvog:read"],
    //     request: {
    //         endpoint: "/grondvog",
    //         params: ["aantaldae=14"]
    //     },
    //     filters: [{
    //             active: true,
    //             name: "Datumreeks",
    //             type: "daterange"
    //         },
    //         // {
    //         //     active: false,
    //         //     defaultsetup: {
    //         //         value: 14,
    //         //         metric: "days"
    //         //     },
    //         //     name: "Tye",
    //         //     type: "timeseries",
    //         //     setup: [{
    //         //             name: "1 dag",
    //         //             value: 1,
    //         //             metric: "days"
    //         //         },
    //         //         {
    //         //             name: "7 dae",
    //         //             value: 7,
    //         //             metric: "days"
    //         //         },
    //         //         {
    //         //             name: "1 maand",
    //         //             value: 1,
    //         //             metric: "months"
    //         //         }
    //         //     ]
    //         // }
    //     ],
    //     layertipes: [
    //         // {
    //         //     key: 3,
    //         //     active: false,
    //         //     name: "Heatmap",
    //         //     type: "weightedheatmap",
    //         //     options: {},
    //         //     infooverlay: true
    //         // },
    //         {
    //             key: 1,
    //             active: false,
    //             name: "Merkers",
    //             type: "markers",
    //             options: {
    //                 custommarkers: true,
    //                 label: "value",
    //                 markers: [
    //                     "pin_1.svg",
    //                     "pin_2.svg",
    //                     "pin_3.svg",
    //                     "pin_4.svg",
    //                     "pin_5.svg"
    //                 ]
    //             }
    //         },
    //         {
    //             key: 2,
    //             active: true,
    //             name: "Radius merkers",
    //             type: "markers",
    //             options: {
    //                 custommarkers: true,
    //                 markers: [
    //                     "radiuspin_1.svg",
    //                     "radiuspin_2.svg",
    //                     "radiuspin_3.svg",
    //                     "radiuspin_4.svg",
    //                     "radiuspin_5.svg"
    //                 ]
    //             }
    //         }
    //     ],
    //     infobox: {
    //         title: "value",
    //         subtitle: "date",
    //         info: "capturer"
    //     }
    // },
    // {
    //     id: 3,
    //     naam: "Onkruidverkenning",
    //     permissions: ["onkruid:read"],
    //     request: {
    //         endpoint: "/onkruidverkenning",
    //         params: ["aantaldae=14"]
    //     },
    //     filters: [{
    //         active: true,
    //         name: "Datumreeks",
    //         type: "daterange"
    //     }],
    //     layertipes: [{
    //             key: 1,
    //             active: false,
    //             name: "Heatmap",
    //             type: "weightedheatmap",
    //             options: {},
    //             infooverlay: true
    //         },
    //         {
    //             key: 2,
    //             active: true,
    //             name: "Merkers",
    //             type: "markers",
    //             options: {
    //                 label: "value"
    //             }
    //         }
    //     ],
    //     infobox: {
    //         title: "value",
    //         subtitle: "date",
    //         info: "capturer"
    //     }
    // }
];

export default layers;